'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'shield';
var width = 512;
var height = 512;
var aliases = [128737];
var unicode = 'f132';
var svgPathData = 'M466.5 83.71l-192-80C268.6 1.202 262.3 0 256 0S243.5 1.202 237.6 3.702l-192 80C27.73 91.08 16 108.6 16 127.1c0 257.5 189.5 384 239.1 384c49.26 0 240-124.7 240-384C496 108.6 484.2 91.08 466.5 83.71zM256 463.9V48.09L448 128C448 330.5 322.5 436.3 256 463.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faShield = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;